import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateWatermarkBodyDto, UpdateWatermarkBodyDto, WatermarkDto } from '@picflow/types';
import { lastValueFrom } from 'rxjs';
import { AppConfigService } from '../providers/config.service';
import { DataLoaderService } from './data-loader.service';
import { FeatureFlagsService } from './feature-flags.service';

@Injectable({
  providedIn: 'root',
})
export class WatermarkService {
  constructor(
    private http: HttpClient,
    private config: AppConfigService,
    private loader: DataLoaderService,
    private featureFlags: FeatureFlagsService
  ) {}

  public async getWatermarks() {
    return this.loader.get('watermarks', () => this.getWatermarksInternal());
  }

  public async getWatermark(watermarkId: string) {
    const watermarks = await this.loader.getFromCache<WatermarkDto[]>('watermarks');
    const watermark = watermarks?.find(w => w.id === watermarkId);
    if (watermark) return watermark;
    return this.loader.get('watermarks_' + watermarkId, () => this.getWatermarkInternal(watermarkId));
  }

  public async createWatermark(params: CreateWatermarkBodyDto) {
    const resp = await lastValueFrom(this.http.post<WatermarkDto>(`${this.config.apiEndpoint}/watermarks`, params));
    this.loader.removeFuzzy('watermarks');
    return resp;
  }

  public async deleteWatermark(watermarkId: string) {
    await lastValueFrom(this.http.delete(`${this.config.apiEndpoint}/watermarks/${watermarkId}`));
    this.loader.removeFuzzy('watermarks');
  }

  public async updateWatermark(watermarkId: string, params: UpdateWatermarkBodyDto) {
    const resp = await lastValueFrom(
      this.http.patch<WatermarkDto>(`${this.config.apiEndpoint}/watermarks/${watermarkId}`, params)
    );
    this.loader.removeFuzzy('watermarks');
    return resp;
  }

  private async getWatermarksInternal() {
    const resp = await lastValueFrom(this.http.get<{ data: WatermarkDto[] }>(`${this.config.apiEndpoint}/watermarks`));
    return resp.data;
  }

  private async getWatermarkInternal(id: string) {
    const resp = await lastValueFrom(this.http.get<WatermarkDto>(`${this.config.apiEndpoint}/watermarks/${id}`));
    return resp;
  }
}
